/* eslint-disable */
import { cloneDeep, difference, defer } from 'lodash'
import { getDepth, getTreeFromFlatData, walk, getDescendantCount, isDescendant } from 'react-sortable-tree'
import { NodeById } from '../helper/classes'
import { BFS, DFS } from './basicAlgorithm'
import { cutDescendantLevel, getScoreByRating, magnitudeCriteria, scoreMargin } from './constants'
import voca from 'voca'
import { getNodeKey } from '../components/list/window1/functions'
import { getParentKey, getTodayNumber, isDueDate } from './functions'
import { produce } from 'immer'
import { getReadyForSpreadsheet, nodeToSpreadsheetRootNode } from './spreadsheet'
import { globalOnDemandVars } from '../helper/context'
import { getReadyForUploadType2, nodeToUploadType2RootNode } from './uploadType2'
import { uniqueId } from 'lodash'

let dummyTreeData1, dummyRootNode1, dummyTreeData2, nodesThatsDueDate
if (process.env.NODE_ENV !== 'production') {
  dummyTreeData1 = [
    {
      title: 'tmp',
      subtitle: '',
      id: 55,
      parentId: 'rootNode',
      children: [
        {
          title: '12214124-log',
          subtitle: 'despised',
          parentId: 55,
          id: 66
        },
        {
          title: 'drag-disabled-file',
          subtitle: '',
          id: 77,
          parentId: 55,
          children: [
            {
              title: 'build',
              subtitle: 'despised',
              id: 88,
              parentId: 77,
              children: [{
                title: 'react-sortable-tree.js',
                subtitle: '',
                id: 99,
                parentId: 88,
                children: [{
                  title: 'itShouldBeDeleted',
                  subtitle: '',
                  id: 121324,
                  parentId: 99,
                }]
              }]
            }
          ]
        }
      ]
    },
    {
      title: '.gitignoredespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddd',
      subtitle: 'despised',
      id: 1,
      parentId: 'rootNode',
      expanded: true
    },
    {
      title: 'ddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddd',
      subtitle: '$ df ㄱㄴㄷ$',
      id: 2,
      parentId: 'rootNode',
      expanded: true
    },
    {
      title: 'apple',
      subtitle: '$ df  \\ $',
      id: 3,
      parentId: 'rootNode',
      expanded: true,
      children: [
        {
          title: 'ddddddddddddddddd\nddddddddddddddddddddddddddddd\na\nc\na',
          subtitle: 'ddddddddddddddddddddd',
          id: 4,
          parentId: 3,
          expanded: false,
          children: [
            {
              title: 'ddddddddddddddddd\nddddddddddddddddddddddddddddd\nb\nc\na',
              subtitle: 'ddddddddddddddddddddd',
              id: 6,
              parentId: 4,
              expanded: true
            },
            {
              title: 'bold',
              subtitle: '',
              id: 5,
              parentId: 4,
              expanded: true
            },
            {
              title: '$$ df  \\int_x^y \\sum_x^y $$ <- $$',
              subtitle: '$ df  \\int_x^y \\sum_x^y $ <- $',
              id: 7,
              parentId: 4,
              expanded: true
            },
            {
              title: 'actions.js',
              subtitle: '',
              id: 8,
              parentId: 4,
              expanded: true
            },
            {
              title: 'utils.js',
              subtitle: 'despised',
              id: 9,
              parentId: 4,
              expanded: true
            }
          ]

        },
        {
          title: '# bold',
          subtitle: '',
          id: 11,
          parentId: 3,
          expanded: true
        },
        {
          title: '$$ df  \\int_x^y \\sum_x^y $$ <- $$',
          subtitle: '$ df  \\int_x^y \\sum_x^y $ <- $',
          id: 22,
          parentId: 3,
          expanded: true
        },
        {
          title: 'actions.js',
          subtitle: '',
          id: 33,
          parentId: 3,
          expanded: true
        },
        {
          title: 'utils.js',
          subtitle: 'despised',
          id: 44,
          parentId: 3,
          expanded: true
        }
      ]
    }
  ]

// dummyTreeData1 = getFlatDataFromTree({
//   treeData: dummyTreeData1,
//   getNodeKey: ({node}) => (node.id),
//   ignoreCollapsed: false
// })/*?*/
// dummyTreeData1 = getTreeFromFlatData({
//   flatData: dummyTreeData1,
//   getKey: ({node}) => (node.id),
//   getParentKey: ({parentNode}) => (parentNode && parentNode.id),
//   ignoreCollapsed: false
// })/*?*/

  dummyRootNode1 = {
    id: 'rootNode',
    children: dummyTreeData1/*?*/
  }/*?*/
  BFS(dummyRootNode1, (node) => {
    node.editableValues = {}
  })
  dummyTreeData2 = cloneDeep(dummyTreeData1)

  BFS(dummyRootNode1, (node) => {
    node.editableValues.ratingRecord = [{ rating: 'easy', time: Date.now() }]
  })

  dummyRootNode1/*?*/

  nodesThatsDueDate = [
    1, 3, 7, 44, 99
  ]
}
// -----------------------------------------------------------------------------------------------------------

const regexFor$$ = /(^\$.*[^\\]\$|[^\\]\$.*[^\\]\$)/
const regexForMediaBlock = /!\[.*?]\(.*?\)/g
const getKey = (node) => (node.id)

// -----------------------------------------------------------------------------------------------------------

function isAlmostFailed (ratingRecord, lastRating) {
  const length = ratingRecord.length
  return lastRating === 'hard' && ((length === 2 && ratingRecord[0].rating === 'fail') || (length >= 4 && ratingRecord[length - 2].rating === 'fail' && ratingRecord[length - 4].rating === 'fail'))
}

function getDefaultMemorizingStatus (node) {
  const ratingRecord = node.editableValues.ratingRecord
  const length = ratingRecord ? ratingRecord.length : null
  if (ratingRecord && length) {
    const lastRating = ratingRecord[length - 1].rating
    if (lastRating !== 'fail') {
      if (isAlmostFailed(ratingRecord, lastRating)) {
        return 'fail'
      } else {
        return lastRating
      }
    } else {
      throw (new Error())
    }
  } else {
    return 'firstTime'
  }
}

export function getDownedRating (currentDifficulty) {
  switch (currentDifficulty) {
    case 'easy':
      return 'easy'
    case 'normal':
      return 'easy'
    case 'hard':
      return 'normal'
    default:
      throw (new Error())
  }
}

export function getUppedRating (currentDifficulty) {
  switch (currentDifficulty) {
    case 'easy':
      return 'normal'
    case 'normal':
      return 'hard'
    case 'hard':
      return 'fail'
    default:
      throw (new Error())
  }
}

export function getUpCriteriaDate (interval, difficulty, config) {
  const { intervalWeightForUp, difficultyWeightForUp } = config || globalOnDemandVars.ratingConstants()

  return (interval * intervalWeightForUp) * (1 - (difficulty * difficultyWeightForUp))
}

function shouldBeUpped (remainedDate, interval, difficulty, status, ratingRecord) {
  if (status === 'hard' && (ratingRecord.reduce((accu, curr) => (accu + (curr.rating === 'fail' ? 1 : 0)), 0) < globalOnDemandVars.ratingConstants().failC)) {
    return false
  }

  const criteriaDate = getUpCriteriaDate(interval, difficulty)
  const resultBoolean = remainedDate >= criteriaDate

  // TODO 여기서 0.8 은 그냥 임의의 숫자임
  remainedDate -= 0.8 * criteriaDate

  return resultBoolean
}

export function getDownCriteriaDate (interval, difficulty, config) {
  const { intervalWeightForDown, difficultyWeightForDown } = config || globalOnDemandVars.ratingConstants()

  return ((interval * intervalWeightForDown) * (1 - (difficulty * difficultyWeightForDown)))
}

function shouldBeDowned (remainedDate, interval, difficulty, ratingRecord, lastRating) {
  if (isAlmostFailed(ratingRecord, lastRating)) {
    return false
  }

  const { intervalWeightForDown, difficultyWeightForDown } = globalOnDemandVars.ratingConstants()

  return remainedDate <= getDownCriteriaDate(interval, difficulty)
}

export function getMemorizingStatus (node) {
  const ratingRecord = node.editableValues.ratingRecord
  const length = ratingRecord ? ratingRecord.length : null
  if (ratingRecord && length) {
    const lastRating = ratingRecord[length - 1].rating
    const difficulty = node.editableValues.difficulty
    const interval = node.editableValues.interval
    const todayNumber = getTodayNumber(true)
    const dueDate = node.editableValues.update + node.editableValues.interval
    let remainedDate = todayNumber - dueDate
    let status = lastRating

    if (remainedDate <= 0) {
      if (!isAlmostFailed(ratingRecord, lastRating)) {
        return getDownedRating(status)
      } else {
        return lastRating
      }
    } else if (shouldBeUpped(remainedDate, interval, difficulty, status, ratingRecord)) {
      status = getUppedRating(status)
      while (status !== 'fail' && shouldBeUpped(remainedDate, interval, difficulty, status, ratingRecord) === true) {
        status = getUppedRating(status)
      }
      return status
    } else if (shouldBeDowned(remainedDate, interval, difficulty, ratingRecord, lastRating)) {
      return getDownedRating(status)
    } else {
      return getDefaultMemorizingStatus(node)
    }
  } else {
    return 'firstTime'
  }
}

// globalTreeData 복사하고, 복사된 트리에 계산된 memorizingStatus 를 붙이는거임
function generatingEditedTreeData (treeData, nodes) {
  const newTD = cloneDeep(treeData)

  const walkCallback = ({
    node,
    parentNode,
    path,
    lowerSiblingCounts,
    treeIndex
  }) => {
    if (nodes.some((id) => (id === getNodeKey({ node })))) {
      node.editableValues.memorizingStatus = getMemorizingStatus(node)
    }
  }
  walk({
    treeData: newTD,
    ignoreCollapsed: false,
    getNodeKey: getNodeKey,
    callback: walkCallback
  })

  return newTD
}

// function generatingEditedTreeData2 (treeData, nodes) {
//   return cloneDeepWith(treeData, (node) => {
//       if (nodes.some((id) => (id === getNodeKey({ node })))) {
//         node.editableValues.memorizingStatus = getMemorizingStatus(node)
//       }
//     }
//   )
// }
const parentIdsOfIds = {}
const getAncestorIdArray = (node, includingSelfId) => {
  const result = []
  let parentId = null
  let nodeId = node.id

  if (includingSelfId) {
    result.push(nodeId)
  }

  while (parentId !== 'rootNode' && parentId !== undefined) {
    parentId = parentIdsOfIds[nodeId]
    result.push(parentId)
    nodeId = parentId
  }

  return result
}

function getNodeCountFromTreeData (treeData) {
  let count = 0
  treeData.forEach((node) => {
    if (node.subtitle) {
      count += 1
    }
    if (node.isSpreadsheet) {
      const spreadsheetId = node.spreadsheetId
      const spreadsheet = globalOnDemandVars.spreadsheets()[spreadsheetId]
      let rows = spreadsheet.rows
      rows = rows.filter((row) => {
        const frontArray = spreadsheet.selectedItems1
        const backArray = spreadsheet.selectedItems2

        return frontArray.some((key) => !!row[key]) && backArray.some((key) => !!row[key])
      })
      count += rows.length
    }
    if (node.isUploadType2) {
      const uploadType2Id = node.uploadType2Id
      const uploadType2 = globalOnDemandVars.uploadType2s()[uploadType2Id]
      const fragments = uploadType2.fragmentList
      count += fragments.length
    }
    if (node.children && node.children.length) {
      count += getNodeCountFromTreeData(node.children)
    }
  })

  return count
}

export function generatingEditedTreeData3 (treeData, dueDateSet, reStudySet, reTestSet, totalScoreObject, dontSkip) {
  const skipIds = globalOnDemandVars.skipIds()
  if (skipIds.findIndex((skipId) => (skipId === 'rootNode')) !== -1) {
    return []
  }
  const skippedTreeData = treeData.filter((node) => (!skipIds.some((skipId) => {
    const skippedNode = (new NodeById(skipId)).getNode()
    return (skipId === node.id || (skippedNode ? isDescendant(skippedNode, node) : false))
  })))

  const newTD = cloneDeep(skippedTreeData)
  const dailyLimitOn = globalOnDemandVars.dailyLimitOn()
  const dailyLimit = globalOnDemandVars.dailyLimit()
  const thoroughIds = globalOnDemandVars.thoroughIds().concat(globalOnDemandVars.addedThoroughIds())

  const walkCallback = ({
                          node,
                          parentNode,
                          path,
                          lowerSiblingCounts,
                          treeIndex
                        }) => {

    parentIdsOfIds[node.id] = getParentKey(node)

    // 여기서 뭐 바꿀거면 getReadyForSpreadsheet 도 바꿔야 됨
    if (dailyLimitOn && (dailyLimit <= totalScoreObject.nodeCountAtFirst)) {
      return false
    }

    if (!dontSkip && skipIds.some((oneId) => {
      const shouldThisNodeSkipped = (oneId === node.id || oneId === 'rootNode')

      defer(() => {
        if (shouldThisNodeSkipped) {
          if (oneId === 'rootNode') {
            globalOnDemandVars.set_courseStatus(produce(globalOnDemandVars.courseStatus(), draft => {
              draft.skippedNodes = [globalOnDemandVars.topRootName()]
            }))
          } else if (oneId === node.id) {
            globalOnDemandVars.set_courseStatus(produce(globalOnDemandVars.courseStatus(), draft => {
              if (Array.isArray(draft.skippedNodes)) {
                draft.skippedNodes.push(node.title)
              } else {
                draft.skippedNodes = [ node.title ]
              }
            }))
          }
        }
      })

      return shouldThisNodeSkipped
    })) {
      node.children = null
      node.isSpreadsheet = false
      node.isUploadType2 = false
      return true
    }

    if (node.editableValues.failStatus && node.editableValues.failStatus !== 'solved' && node.subtitle) {
      switch (node.editableValues.failStatus) {
        case 'reStudy':
          reStudySet.add(node.id)
          node.editableValues.memorizingStatus = 'reStudy'
          totalScoreObject.score += getScoreByRating('reStudy')
          totalScoreObject.score += getScoreByRating('reTest')
          totalScoreObject.nodeCountAtFirst += 1
          break
        case 'reTest':
          reTestSet.add(node.id)
          node.editableValues.memorizingStatus = 'reTest'
          totalScoreObject.score += getScoreByRating('reTest')
          totalScoreObject.nodeCountAtFirst += 1
          break
      }
    } else if (isDueDate(node) || (thoroughIds.some((oneId) => {
      const isThisNodeThorough = ((oneId === 'rootNode') || oneId === node.id || (path.some((pathId) => (oneId === pathId))))

      defer(() => {
        if (isThisNodeThorough) {
          if (oneId === 'rootNode') {
            globalOnDemandVars.set_courseStatus(produce(globalOnDemandVars.courseStatus(), draft => {
              draft.thoroughNodes = [globalOnDemandVars.topRootName()]
            }))
          } else if (oneId === node.id) {
            globalOnDemandVars.set_courseStatus(produce(globalOnDemandVars.courseStatus(), draft => {
              if (Array.isArray(draft.thoroughNodes)) {
                draft.thoroughNodes.push(node.title)
              } else {
                draft.thoroughNodes = [ node.title ]
              }
            }))
          }
        }
      })

      return isThisNodeThorough
    }) && node.subtitle)) {
      dueDateSet.add(node.id)
      const memorizingStatus = getMemorizingStatus(node)
      node.editableValues.memorizingStatus = memorizingStatus
      totalScoreObject.score += getScoreByRating(memorizingStatus)
      totalScoreObject.nodeCountAtFirst += 1

      if (memorizingStatus === 'firstTime') {
        node.editableValues.firstTime = true
        totalScoreObject.firstTimeNodeCount += 1
      }
    }
  }
  walk({
    treeData: newTD,
    ignoreCollapsed: false,
    getNodeKey: getNodeKey,
    callback: walkCallback
  })

  totalScoreObject.allNodeCount += getNodeCountFromTreeData(newTD)

  return newTD
}

// let editedTD1, editedTD2, editedTD3, editedTD4
//   if (process.env.NODE_ENV !== 'production') {
//   editedTD1 = generatingEditedTreeData(dummyRootNode1.children, nodesThatsDueDate)/*?. $*/
//   editedTD2 = generatingEditedTreeData(dummyRootNode1.children, nodesThatsDueDate)/*?. $*/
//
//   editedTD1, editedTD2
//
//   editedTD3 = generatingEditedTreeData(dummyTreeData2, nodesThatsDueDate)/*?. $*/
//   editedTD4 = generatingEditedTreeData(dummyTreeData2, nodesThatsDueDate)/*?. $*/
//
// }

// -----------------------------------------------------------------------------------------------------------

export function cutDescendant (node, level) {
  if (node.isSpreadsheetRootNode || node.isUploadType2RootNode) {
    return node
  }

  function localF (node, currentLevel) {

    const newChildren = (level === currentLevel || !node.children) ? null : (
      node.children.map((node) => localF(node, currentLevel + 1))
    )

    const { children, ...nodeContent } = node

    return {
      ...nodeContent,
      children: newChildren
    }
  }

  return localF(node, 0)
}

function shouldNodeBeContained (node, memorizingStatus) {
  //  children.length === 1 인 노드는 맥락으로서 의지할 수 없다는 휴리스틱 -> 그래서 그 노드를 title node 로 넣는 대신 부모 노드를 title node 로 해서 맥락 노드를 하나 더 보여주는 효과
  // 그리고 그러면서 빠지는 노드가 생기지 않도록 하는 순서로 if 문 배열

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'shouldNodeBeContained',
      preview: node.title,
      value: {
        node, memorizingStatus
      }
      // , important: true
    })
  }

  if (node.children.some((childNode) =>
    (childNode.children && childNode.children.length === 1 && childNode.children[0].editableValues.memorizingStatus === memorizingStatus)
  )) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('shouldNodeBeContained 1')
    }
    return true
  } else if (node.id !== 'rootNode' && node.children.length === 1) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('shouldNodeBeContained 2')
    }
    return false
  } else if (node.children.some((childNode) => (childNode.editableValues.memorizingStatus === memorizingStatus))) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('shouldNodeBeContained 3')
    }
    return true
  } else {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('shouldNodeBeContained 4')
    }
    return false
  }
}

const regexForMediaId = /!\[.*?]\((.*?)\)/
export function distributeFromEditedTD (treeData, spreadsheetRootNodes, uploadType2RootNodes, dueDateSet, reStudySet, reTestSet, totalScore) {
  const mediaIdSet = new Set()

  let easyList = []
  let normalList = []
  let hardList = []
// failList가 개념상으로 있긴하지만 지금의 방식으로는 아무것도 여기 안들어감.. 나중에 타임시리즈로 추정할땐 되겠지
  let failList = []
  let firstTimeList = []

  let reStudyList = []
  let reTestList = []

  const dummyRoot = {
    id: 'rootNode',
    children: treeData
  }

  DFS(dummyRoot, (node) => {
    if (node.children && node.children.length) {
      if (shouldNodeBeContained(node, 'easy')) {
        easyList.push(node)
      }
      if (shouldNodeBeContained(node, 'normal')) {
        normalList.push(node)
      }
      if (shouldNodeBeContained(node, 'hard')) {
        hardList.push(node)
      }
      if (shouldNodeBeContained(node, 'fail')) {
        failList.push(node)
      }
      if (shouldNodeBeContained(node, 'firstTime')) {
        firstTimeList.push(node)
      }

      if (shouldNodeBeContained(node, 'reStudy')) {
        reStudyList.push(node)
      }
      if (shouldNodeBeContained(node, 'reTest')) {
        reTestList.push(node)
      }

    }
    // -----------------------------------------------------------------------------------------------------------
    if (node.isSpreadsheet) {
      const spreadsheetRootNode = nodeToSpreadsheetRootNode(node)
      getReadyForSpreadsheet(spreadsheetRootNode, dueDateSet, reStudySet, reTestSet, totalScore, getAncestorIdArray(node))

      easyList.push(spreadsheetRootNode)
      normalList.push(spreadsheetRootNode)
      hardList.push(spreadsheetRootNode)
      failList.push(spreadsheetRootNode)
      firstTimeList.push(spreadsheetRootNode)
      reStudyList.push(spreadsheetRootNode)
      reTestList.push(spreadsheetRootNode)
      spreadsheetRootNodes.push(spreadsheetRootNode)
    } else if (node.isUploadType2) {
      const uploadType2RootNode = nodeToUploadType2RootNode(node)
      getReadyForUploadType2(uploadType2RootNode, dueDateSet, reStudySet, reTestSet, totalScore, getAncestorIdArray(node))

      easyList.push(uploadType2RootNode)
      normalList.push(uploadType2RootNode)
      hardList.push(uploadType2RootNode)
      failList.push(uploadType2RootNode)
      firstTimeList.push(uploadType2RootNode)
      reStudyList.push(uploadType2RootNode)
      reTestList.push(uploadType2RootNode)
      uploadType2RootNodes.push(uploadType2RootNode)
    }

    const mediaStrings = (String(node.title) + String(node.subtitle)).match(regexForMediaBlock)

    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'mediaStrings',
        value: {
          mediaStrings
        }
        // , important: true
      })
    }

    if (mediaStrings) {
      mediaStrings
        .map((mediaString) => (regexForMediaId.exec(mediaString)[1]))
        .filter((mediaId) => (!mediaIdSet.has(mediaId)))
        .map((mediaId) => (globalOnDemandVars.uploadType2s()[mediaId]))
        .filter((maybeItem) => {
          return maybeItem && maybeItem.fragmentList && maybeItem.fragmentList.length
        })
        .forEach((mediaItem) => {
          mediaIdSet.add(mediaItem.id)

          const uploadType2RootNode = nodeToUploadType2RootNode({
            ...node,
            title: mediaItem.title,
            id: node.id,
            uploadType2Id: mediaItem.id,
            isUploadType2: true
          })

          getReadyForUploadType2(uploadType2RootNode, dueDateSet, reStudySet, reTestSet, totalScore, getAncestorIdArray(node))

          easyList.push(uploadType2RootNode)
          normalList.push(uploadType2RootNode)
          hardList.push(uploadType2RootNode)
          failList.push(uploadType2RootNode)
          firstTimeList.push(uploadType2RootNode)
          reStudyList.push(uploadType2RootNode)
          reTestList.push(uploadType2RootNode)
          uploadType2RootNodes.push(uploadType2RootNode)
        })
    }
  })

  const callbackfn = (node) => cutDescendant(node, cutDescendantLevel)
  easyList = easyList.map(callbackfn)
  normalList = normalList.map(callbackfn)
  hardList = hardList.map(callbackfn)
  failList = failList.map(callbackfn)
  firstTimeList = firstTimeList.map(callbackfn)

  reStudyList = reStudyList.map(callbackfn)
  reTestList = reTestList.map(callbackfn)

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'shouldNodeBeContained / list return',
      value: {
        easyList, normalList, hardList, failList, firstTimeList, reStudyList, reTestList
      }
      // , important: true
    })
  }

  return {
    easyList, normalList, hardList, failList, firstTimeList, reStudyList, reTestList
  }
}

// if (process.env.NODE_ENV !== 'production') {
//   editedTD1 = distributeFromEditedTD(editedTD1)/*?. $*/
//   editedTD2 = distributeFromEditedTD(editedTD2)/*?. $*/
//   editedTD3 = distributeFromEditedTD(editedTD3)/*?. $*/
//   editedTD4 = distributeFromEditedTD(editedTD4)/*?. $*/
// }

// -----------------------------------------------------------------------------------------------------------

function getScoreOfNode (currentNode, expectedRating, maxScore) {
  if (!currentNode) {
    return 0
  }

  let totalScore = 0
  BFS(currentNode, (node) => {
    if (currentNode.id !== node.id && node.editableValues && node.editableValues.memorizingStatus === expectedRating) {
      totalScore += getScoreByRating(expectedRating)
    }
    if (totalScore > maxScore) {
      return false
    }
  })
  if (process.env.NODE_ENV !== 'production') {
  console.tron.display({
    name: 'logic / getScoreOfNode',
    preview: expectedRating ,
    value: {
      currentNode, expectedRating, totalScore
    }
    // , important: true
  })
}
  return totalScore
}

function cutRow (spreadsheetRootNode, score, expectedRating, getSingleCard) {
  const scoreByRating = getScoreByRating(expectedRating)

  const newChildren = []
  const prevChildren = spreadsheetRootNode.children

  if (getSingleCard) {
    const firstCard = prevChildren.find((prevChild) => prevChild.editableValues && prevChild.editableValues.memorizingStatus === expectedRating)
    newChildren.push(firstCard)
  } else {
    let index = 0
    let soFarScore = 0
    while (soFarScore < score && index < prevChildren.length) {
      const prevChild = prevChildren[index]
      if (prevChild.editableValues && prevChild.editableValues.memorizingStatus === expectedRating) {
        newChildren.push(prevChild)
        soFarScore += scoreByRating
      }

      index += 1
    }
  }

  return {
    ...spreadsheetRootNode,
    children: newChildren,
    cutAlready: true
  }
}

function cutFragment (uploadType2RootNode, score, expectedRating, getSingleCard) {
  const scoreByRating = getScoreByRating(expectedRating)

  const newChildren = []
  const prevChildren = uploadType2RootNode.children

  if (getSingleCard) {
    const firstFragment = prevChildren.find((prevChild) => prevChild.editableValues && prevChild.editableValues.memorizingStatus === expectedRating)
    newChildren.push(firstFragment)
  } else {
    let index = 0
    let soFarScore = 0
    while (soFarScore < score && index < prevChildren.length) {
      const prevChild = prevChildren[index]
      if (prevChild.editableValues && prevChild.editableValues.memorizingStatus === expectedRating) {
        newChildren.push(prevChild)
        soFarScore += scoreByRating
      }

      index += 1
    }
  }

  return {
    ...uploadType2RootNode,
    children: newChildren,
    cutAlready: true
  }
}


function cutNodeByBFS (node, score, expectedRating) {

  if (process.env.NODE_ENV !== 'production') {
  console.tron.display({
    name: 'logic / cutNodeByBFS 1',
    value: {
      node, score, expectedRating
    }
    // , important: true
  })
}
  // const copiedNode = cloneDeep(node)
  let totalScore = 0

  let passedNodes = []

  BFS(node, (currentNode) => {
    if (currentNode.id === node.id) {
      return
    }

    if (currentNode.editableValues && currentNode.editableValues.memorizingStatus === expectedRating) {
      if (score >= totalScore + getScoreByRating(expectedRating)) {
        passedNodes.push(currentNode)
        totalScore += getScoreByRating(expectedRating)
      } else {
        if (totalScore === 0) {
          passedNodes.push(currentNode)
        }
        return false
      }
    } else {
      passedNodes.push(currentNode)
    }
  })

  passedNodes = passedNodes.map((node) => ({
    ...node,
    children: null
  }))
  const newNodeChildren = getTreeFromFlatData({
    flatData: passedNodes/*?*/,
    getKey: getKey,
    getParentKey: getParentKey,
    rootKey: node.id/*?*/
  })/*?*/

  if (process.env.NODE_ENV !== 'production') {
  console.tron.display({
    name: 'logic / cutNodeByBFS 2',
    value: {
      passedNodes,
      newNodeChildren,
      newNode: {
        ...node,
        children: newNodeChildren
      },
      score, expectedRating
    }
    // , important: true
  })
}


  return {
    ...node,
    children: newNodeChildren
  }
}

function detectNodeIdsInSet (idsToDetect, idsNotToDetect, Set) {
  const idsToDetectReally = difference(idsToDetect, idsNotToDetect)

  return idsToDetectReally.some((oneId) => (Set.has(oneId)))
}
function cutBunch (bunch, config, idsOfUpperNodes, expectedRating, orderByTree, withWrongAncestor) {
  // TODO  여기서 withWrongAncestor 검사하는 부분에서 reStudySet 과 reTestSet 뿐만 아니고 다른 것들도 검사할 수 있겠지...? 부모자식간 둘다가 퀴즈인 경우가 안되도록 말이여
  if (bunch.isSpreadsheetRootNode || bunch.isUploadType2RootNode) {
    const parentKey = getParentKey(bunch)
    const ancestorIdArray = getAncestorIdArray(bunch, true)

    if (withWrongAncestor !== 'one' &&
      ((withWrongAncestor === 'two' && (config.reStudySet.has(parentKey) || config.reTestSet.has(parentKey))) ||
        (withWrongAncestor === 'three' && (ancestorIdArray.some((id) => (config.reStudySet.has(id) || config.reTestSet.has(id))))))) {
      return null
    } else if (orderByTree && detectNodeIdsInSet(ancestorIdArray, idsOfUpperNodes, config.dueDateSet)) {
      return null
    } else {
      return bunch
    }
  } else {
    const parentKey = getParentKey(bunch)
    const ancestorIdArray = getAncestorIdArray(bunch)

    if (withWrongAncestor !== 'one' &&
      ((withWrongAncestor === 'two' && (config.reStudySet.has(parentKey) || config.reTestSet.has(parentKey))) ||
        (withWrongAncestor === 'three' && (ancestorIdArray.some((id) => (config.reStudySet.has(id) || config.reTestSet.has(id))))))) {
      return null
    } else if (orderByTree && detectNodeIdsInSet(ancestorIdArray, idsOfUpperNodes, config.dueDateSet)) {
      return null
    } else {
      const nextIdsOfUpperNodes = (bunch.editableValues && bunch.editableValues.memorizingStatus === expectedRating) ? idsOfUpperNodes.concat(bunch.id) : idsOfUpperNodes
      return produce(bunch, draft => {
        draft.children = !draft.children ? null : (draft.children.map((node) => cutBunch(node, config, nextIdsOfUpperNodes, expectedRating, orderByTree, withWrongAncestor))).filter((node) => node)
      })
    }
  }
}

export function getNextBunchFromList (list, expectedRating, score, cuttingConfig) {
  // version 2: 덩어리의 원형을 유지하는 초점을 뒀던 version 1 대신, 트리의 위에 있는 것들이 우선으로 먼저 나오는 데 초점을 둠
  if (!list.length) {
    return null
  }

  let targetBunch, scoreOfTargetBunch, bunchWithMaximumScore
  let soFarMaximumScore = 0
  const nodeIndexForDeleting = []
  for (let i = 0; i < list.length; i++) {
    let currentBunch = list[i]

    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'logic / currentBunch 1',
        value: {
          currentBunch
        }
        // , important: true
      })
    }

    let scoreOfCurrentBunch = getScoreOfNode(currentBunch, expectedRating, score)
    if (!currentBunch || scoreOfCurrentBunch === 0) {
      nodeIndexForDeleting.push(i)
      continue
    }

    if (cuttingConfig) {
      currentBunch = cutBunch(currentBunch, cuttingConfig, [], expectedRating, globalOnDemandVars.orderByTree(), globalOnDemandVars.wrongNodeDescendants())
      if (!currentBunch) {
        continue
      }
      if (!currentBunch.isSpreadsheetRootNode && !currentBunch.isUploadType2RootNode) {
        scoreOfCurrentBunch = getScoreOfNode(currentBunch, expectedRating, score)
      }
    }

    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'logic / currentBunch 2',
        value: {
          currentBunch
        }
        // , important: true
      })
    }


    if (scoreOfCurrentBunch === 0) {
      continue
    } else {
      if ((currentBunch.isSpreadsheetRootNode || currentBunch.isUploadType2RootNode) && !currentBunch.isMultiple) {
        targetBunch = currentBunch
        break
      } else if (score <= scoreOfCurrentBunch + scoreMargin) {
        targetBunch = currentBunch
        scoreOfTargetBunch = scoreOfCurrentBunch
        break
      } else {
        if (soFarMaximumScore < scoreOfCurrentBunch) {
          soFarMaximumScore = scoreOfCurrentBunch
          bunchWithMaximumScore = currentBunch
        }
        continue
      }
    }

  }

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'logic / targetBunch 1',
      value: {
        targetBunch
      }
      // , important: true
    })
  }


  nodeIndexForDeleting.forEach((index) => {
    list[index] = undefined
  })

  if (!targetBunch && soFarMaximumScore === 0) {
    return null
  } else if (!targetBunch) {
    targetBunch = bunchWithMaximumScore
    scoreOfTargetBunch = soFarMaximumScore
  }

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'logic / targetBunch 2',
      value: {
        targetBunch
      }
      // , important: true
    })
  }


  if (targetBunch.isSpreadsheetRootNode && !targetBunch.isMultiple) {
    return cutRow(targetBunch, score, expectedRating, true)
  } else if (targetBunch.isUploadType2RootNode && !targetBunch.isMultiple) {
    return cutFragment(targetBunch, score, expectedRating, true)
  } else if (score >= scoreOfTargetBunch) {
    return targetBunch
  } else {
    if (targetBunch.isSpreadsheetRootNode) {
      return cutRow(targetBunch, score, expectedRating)
    } else if (targetBunch.isUploadType2RootNode) {
      return cutFragment(targetBunch, score, expectedRating)
    } else {
      return cutNodeByBFS(targetBunch, score, expectedRating)
    }
  }

  // version 1: 덩어리의 원형들을 최대한 유지하는 데 초점을 뒀었지만, 트리의 위에 있는게 우선으로 먼저 나오는 효과가 너무 떨어져서 다른걸로 바꿈
  // let maximumScoreSoFar = 0
  // let nodeMaximumScore
  // let nodeFitToScore
  // const nodeIndexForDeleting = []
  //
  // for (let i = 0; i < list.length; i++) {
  //   const currentNode = list[i]
  //   if (!currentNode) {
  //     continue
  //   }
  //
  //   const scoreOfNode = getScoreOfNode(currentNode, expectedRating)
  //
  //   if (scoreOfNode === 0) {
  //     nodeIndexForDeleting.push(i)
  //   } else if (Math.abs(scoreOfNode/*?*/ - score) <= scoreMargin) {
  //     nodeFitToScore = currentNode
  //   } else if (scoreOfNode > maximumScoreSoFar) {
  //     nodeMaximumScore = currentNode
  //     maximumScoreSoFar = scoreOfNode
  //   }
  // }
  //
  // // 이 후에 undef인 index의 element를 모두 지우게할 수 있음. list = list.filter() 를 사용해서. 근데 이 함수의 바깥에 해야할듯
  // nodeIndexForDeleting.forEach((index) => {
  //   list[index] = undefined
  // })
  //
  // if (nodeFitToScore) {
  //   return nodeFitToScore
  // } else {
  //   if (maximumScoreSoFar/*?*/ && (maximumScoreSoFar <= score)) {
  //     return nodeMaximumScore
  //   } else if (!maximumScoreSoFar) {
  //     return null
  //   } else {
  //
  //     return cutNodeByBFS(nodeMaximumScore, score, expectedRating)
  //
  //   }
  // }

}

// if (process.env.NODE_ENV !== 'production') {
//   editedTD1 = getNextBunchFromList(editedTD1.easyList/*?*/, 'easy', 3)/*?. $*/
//   editedTD2 = getNextBunchFromList(editedTD2.easyList/*?*/, 'easy', 1)/*?. $*/
//   editedTD3 = getNextBunchFromList(editedTD3.easyList/*?*/, 'easy', 5)/*?. $*/
//   editedTD4 = getNextBunchFromList(editedTD4.firstTimeList/*?*/, 'firstTime', 5)/*?. $*/
//
//   editedTD1, editedTD2
// }

// -----------------------------------------------------------------------------------------------------------

export function prettifier (node, expectedRating) {

  if (process.env.NODE_ENV !== 'production') {
  console.tron.display({
    name: 'logic / prettifier 1',
    value: {
      node, expectedRating
    }
    // , important: true
  })
}

  if (!node) {
    return null
  }

  const nodes = []

  BFS(node, (currentNode) => {
    if (currentNode.id !== node.id && currentNode.editableValues && currentNode.editableValues.memorizingStatus === expectedRating) {
      nodes.push(currentNode)
    }
  })

  let maximumBranchLength = 0
  // 각 node 의 parentNode 들만 모은거임 (자신 제외)
  const getParentKey = (node) => (node.editableValues ? node.editableValues.parentId || node.parentId : undefined)
  const branchesOfNodes = nodes.map((currentNode) => {
    const branch = []

    let nextParentId = getParentKey(currentNode)
    // let nextParentId = currentNode.editableValues.parentId || currentNode.parentId
    while (nextParentId !== node.id) {
      branch.unshift(nextParentId)
      nextParentId = parentIdsOfIds[nextParentId]
    }
    branch.unshift(node.id)

    if (branch.length > maximumBranchLength) {
      maximumBranchLength = branch.length
    }

    return branch
  })

  const survivedNodeIds = new Set()
  nodes.forEach((currentNode) => {
    survivedNodeIds.add(currentNode.id)
  })
  branchesOfNodes.forEach((branch) => {
    branch.forEach((someParentNodeId) => {
      survivedNodeIds.add(someParentNodeId)
    })
  })

  let rootId
  const shouldBeDeletedList = []
  const setForCheckingDuplication = new Set()
  for (let currentItemIndex = 0; currentItemIndex < maximumBranchLength; currentItemIndex++) {

    const nextItemIndex = currentItemIndex + 1
    if (nextItemIndex === maximumBranchLength) {
      rootId = branchesOfNodes[0][currentItemIndex]
      break
    } else {

      setForCheckingDuplication.clear()
      for (let currentBranchIndex = 0; currentBranchIndex < branchesOfNodes.length; currentBranchIndex++) {
        const currentBranch = branchesOfNodes[currentBranchIndex]
        let nextNodeId = currentBranch[nextItemIndex]
        nextNodeId = nextNodeId ? nextNodeId : 'undefined'
        setForCheckingDuplication.add(nextNodeId)
      }

      if (setForCheckingDuplication.size === 1) {
        shouldBeDeletedList.push(branchesOfNodes[0][currentItemIndex])
      } else {
        rootId = branchesOfNodes[0][currentItemIndex]
        break
      }

    }

  }
  if (!rootId) {
    if (process.env.NODE_ENV !== 'production') {
  console.tron.display({
      name: 'logic / prettifier rootId 없음',
      value: {
        rootId,
        branchesOfNodes,
        setForCheckingDuplication: Array.from(setForCheckingDuplication),
      }
      , important: true
    })
}
  }
  //
  // shouldBeDeletedList.forEach((dummyParentId) => {
  //   survivedNodeIds.delete(dummyParentId)
  // })

  let rootNode = null
  let survivedActualNodes = []
  BFS(node, (currentNode) => {
    if (survivedNodeIds.has(currentNode.id)) {
      if (currentNode.id === rootId) {
        rootNode = currentNode
      }
      survivedActualNodes.push(currentNode)
    }
  })

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'logic / prettifier 1.5',
      value: {
        rootId, rootNode, survivedNodeIds, node
      }
      // , important: true
    })
  }

  if (rootNode.children.length === 1 && rootNode.id !== node.id) {
  //  children.length === 1 인 노드는 컨텍스트로서 안좋다는 휴리스틱 -> 더미 패런트 노드들을 삭제하지않고 컨텍스트로 쓰자
    rootId = getParentKey(rootNode)
    rootNode = survivedActualNodes.find((node) => (node.id === rootId))

    survivedActualNodes = survivedActualNodes.filter((node) => (node.id === rootId || shouldBeDeletedList.every((dummyParentId) => (dummyParentId !== node.id))))

  } else {
    survivedActualNodes = survivedActualNodes.filter((node) => shouldBeDeletedList.every((dummyParentId) => (dummyParentId !== node.id)))
  }

  // getTreeFromFlatData 에서 건드리는 노드는 children 재할당 되겠지만 안건드리는 노드도 있고 그걸 위해 다 null로 해버리기
  survivedActualNodes = survivedActualNodes.map((node) => ({
    ...node,
    children: null
  }))

  if (process.env.NODE_ENV !== 'production') {
  console.tron.display({
    name: 'logic / prettifier 2',
    value: {
      node, expectedRating, nodes, survivedNodeIds, survivedActualNodes, branchesOfNodes, parentIdsOfIds, rootNode, rootId
    }
    // , important: true
  })
}

  return {
    rootNode: rootNode,
    chunk: (getTreeFromFlatData({
    flatData: survivedActualNodes,
    getKey: getKey,
    getParentKey: getParentKey,
    rootKey: rootId
  }))
}}

// let editedTD10, editedTD20, editedTD30, editedTD40
// if (process.env.NODE_ENV !== 'production') {
//   editedTD10 = prettifier(editedTD1, 'easy')/*?. $*/
//   editedTD20 = prettifier(editedTD2, 'easy')/*?*/
//   editedTD30 = prettifier(editedTD3, 'easy')/*?*/
//   editedTD40 = prettifier(editedTD4, 'firstTime')/*?*/
// }

// -----------------------------------------------------------------------------------------------------------

function isProperForDistinguish (node) {
  if (!node || !node.title) {
    return false
  } else if (regexFor$$.test(node.title) || regexForMediaBlock.test(node.title)) {
    return false
  } else {
    return true
  }
}

function getNodeById (id, treeData) {
  const subfunctionForOneNode = (node) => {
    if (id === 'rootNode') {
      return { title: '', id: 'rootNode' }
    }

    if (node.id === id) {
      return node
    } else if (node.children) {

      return getNodeById(id, node.children)
    } else {

      return false
    }
  }

  let result
  for (let i = 0; i < treeData.length; i++) {
    const currentNode = treeData[i]

    result = subfunctionForOneNode(currentNode)
    if (result) {
      break
    }
  }
  if (result) {
    return result
  }
}


function getOneContextForDistinguish (node, globalTreeData) {
  let finishLoop = false
  let currentNode = node/*?*/
  let currentParentId = getParentKey(node)/*?*/
  let result = null
  while (!finishLoop) {
    if (currentParentId === 'rootNode') {
      finishLoop = true
      break
    }

    currentNode = getNodeById(currentParentId, globalTreeData)
    currentParentId = getParentKey(currentNode)

    if (isProperForDistinguish(currentNode)) {
      result = currentNode
      finishLoop = true
      break
    }
  }
  return result
}

function isOverForDistinguish (node) {
  // return !node || (node.children && (getDescendantCount({ node, ignoreCollapsed: false }) > 100))
  return !node || (node.children && (node.children.length > 10))
}

export function getContextsForDistinguish (node, globalTreeData) {

  if (node.id === 'rootNode') {
    return []
  }

  const contexts = []

  // if (!isProperForDistinguish(node)) {
    let finishLoop = false
    let currentNode = node
    let currentContext
    while (!finishLoop) {
      currentContext = getOneContextForDistinguish(currentNode, globalTreeData)
      if (contexts.length > 6 || isOverForDistinguish(currentContext)) {
        finishLoop = true
        break
      } else {
        if (currentContext) { contexts.push(currentContext) }
        currentNode = currentContext
      }
    }
  // }

  return contexts.slice(0, 8)
}

// if (process.env.NODE_ENV !== 'production') {
//   getContextsForDistinguish(editedTD1, dummyTreeData1)/*?. $*/
//   getContextsForDistinguish(editedTD2, dummyTreeData1)/*?. $*/
// // TODO null의 context를 얻을 수는 없다는거
// // getContextsForDistinguish(editedTD30, dummyTreeData1)/*?. $*/
//   getContextsForDistinguish(editedTD4, dummyTreeData1)/*?. $*/
// }

// -----------------------------------------------------------------------------------------------------------

export function getCategoryContext (node, globalTreeData, initNode) {
  let finishLoop
  let currentNode = node
  // if (initNode) {
  //   currentNode = getNodeById(getParentKey(initNode), globalTreeData)
  // }
  while (!finishLoop) {
    if (currentNode.id === 'rootNode') {
      finishLoop = true
      break
    }

    // if (isProperForDistinguish(currentNode) && !Boolean(currentNode.subtitle)) {
    if (isProperForDistinguish(currentNode)) {
      if (currentNode.title && ((voca.countWords(currentNode.title) < 5) || (currentNode.title.length < 16))) {
        if (currentNode.children) {
          let magnitude = 0
          currentNode.children.forEach((childNode) => {
            if (childNode.children) {
              childNode.children.forEach((childOfChildNode) => {
                magnitude += getDepth(childOfChildNode)
              })
            }
          })
          if (magnitude >= magnitudeCriteria) {
            finishLoop = true
            break
          }
        }
      }
    }

    currentNode = getNodeById(getParentKey(currentNode), globalTreeData)
  }

  if (currentNode.id === 'rootNode') {
    return null
  } else {
    return currentNode
  }
}

// if (process.env.NODE_ENV !== 'production') {
//   getCategoryContext(editedTD1, dummyTreeData1)/*?. $*/
//   getCategoryContext(editedTD2, dummyTreeData1)/*?. $*/
//   getCategoryContext(editedTD4, dummyTreeData1)/*?. $*/
// }
